import { Typography } from '@mui/material';
import type React from 'react';
import type { Section } from '../../../types/tender';
import { BaseModal } from '../../common/UI';
import { extractTitleTags } from './utils';

interface DeleteSectionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  sectionToDelete: Section | null;
}

export const DeleteSectionDialog: React.FC<DeleteSectionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  sectionToDelete,
}) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Delete this section?"
      onConfirm={onConfirm}
      confirmText="Delete"
      confirmColor="error"
    >
      <Typography>
        Are you sure you want to delete &quot;
        {sectionToDelete ? extractTitleTags(sectionToDelete.title).cleanTitle : ''}&quot;? This
        action cannot be undone.
      </Typography>
    </BaseModal>
  );
};
